import { render, staticRenderFns } from "./SrandardMaterialMasterPhone.vue?vue&type=template&id=2f2b772b&scoped=true"
import script from "./SrandardMaterialMasterPhone.vue?vue&type=script&lang=js"
export * from "./SrandardMaterialMasterPhone.vue?vue&type=script&lang=js"
import style1 from "./SrandardMaterialMasterPhone.vue?vue&type=style&index=1&id=2f2b772b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b772b",
  null
  
)

export default component.exports